import { ITEM_MARK_READ, ITEM_MARK_UNREAD } from '../itemReducer/actionTypes';
import * as actionTypes from './actionTypes';

const countReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.UNREAD_COUNT_SET:
            return {
                ...state,
                [action.source]: action.count,
            };
        case ITEM_MARK_READ:
            return {
                ...state,
                [action.source]: state[action.source] - 1,
            };
        case ITEM_MARK_UNREAD:
            return {
                ...state,
                [action.source]: state[action.source] + 1,
            };
        default:
            return state;
    }
};

export default countReducer;
